import PdfIcon from "../assets/icons/stageIcons/pdfIcon.svg";
import PencilIcon from "../assets/icons/stageIcons/pencilIcon.svg";
import DoneIcon from "../assets/icons/stageIcons/doneIcon.svg";
import ClockIcon from "../assets/icons/stageIcons/clockIcon.svg";
import FileIcon from "../assets/icons/stageIcons/fileIcon.svg";
import QuestionIcon from "../assets/icons/stageIcons/questionIcon.svg";
import MarkIcon from "../assets/icons/stageIcons/markIcon.svg";
export const stageValues = [
  {
    name: "Teste başlamadan önce PDF çıktı al.",
    icon: PdfIcon,
    bgColor: "#DC2626",
  },
  {
    name: "Aldığın çıktı ile kalem avantajını kullan.",
    icon: PencilIcon,
    bgColor: "#EAB308",
  },
  {
    name: "Soruları çözdükçe şıkları işaretle.",
    icon: DoneIcon,
    bgColor: "#16A34A",
  },
  {
    name: "En kısa sürede bitirmeye çalış.",
    icon: ClockIcon,
    bgColor: "#2563EB"
  },
  {
    name: "Test bittiğinde sorulara dönerek notlar al.",
    icon: FileIcon,
    bgColor: "#475569"
  },
  {
    name: "Raporlarım",
    icon: QuestionIcon,
    bgColor: "#EF4444"
  },
  {
    name: "Genel Sıralama",
    icon: MarkIcon,
    bgColor: "#60A5FA",
  },
];